import * as Cookies from 'js-cookie';

if (!Cookies.get('login')) {
  const { origin, pathname } = window.location;
  window.location.replace(`${origin}/fl-into-literature/login.html${pathname.substring(1) && '?' + pathname.substring(1)}`);
}